export const ManualHeadings = {
	coverTitle: ["O Manual da", "Minha Cirurgia"],
	coverClinicSuffix: "Cirurgia Plástica",
	letter: "Uma carta para você",
	summary: "Resumo Executivo",
	summaryIndicated: "O que foi indicado",
	complaints: "Suas Queixas",
	assessment: "O Que Avaliamos",
	assessmentHistory: "Histórico de saúde",
	assessmentPhysical: "Avaliação física",
	plan: "Seu Plano Cirúrgico",
	safety: "Segurança em Primeiro Lugar",
	safetyProtocol: "Protocolo de segurança",
	safetyPreOp: "Cuidados pré-operatórios",
	safetyRecovery: "Recuperação",
	nextSteps: "Próximos Passos",
	risks: "Cuidados Importantes",
	risksGeneral: "Riscos gerais",
	risksSpecific: "Atenções específicas do seu caso",
	investment: "Investimento",
	investmentComposition: "O que compõe",
	investmentBonus: "Bônus da Dra.",
	investmentNotIncluded: "O que NÃO está incluso",
	investmentHospitals: "Hospitais",
	journey: "Uma Jornada Juntas",
} as const;
